/* eslint-disable max-len */
import React, {FC} from "react"

import id from "@irati/utils/id"

import BaseSvgIcon from "./Base"

interface Props {
  id: string
  title: string
}

const Comment: FC<Props> = (props) => {
  const titleId = id("title", props)
  const {title, ...rest} = props

  return (
    <BaseSvgIcon {...rest} aria-labelledby={titleId}>
      <g fillRule="evenodd">
        <rect height="1" rx=".5" width="6" x="5.5" y="5.5" />
        <rect height="1" rx=".5" width="6" x="7" y="8" />
        <path
          d="m2 7.29545455c0 2.73325015 2.74399389 5.02259955 6.35280464 5.27309525l.46537718.0323029v3.2173291c0 .1619827.19584398.243104.31038305.1285649l5.41596783-5.4159467c.0263351-.0259327.0263351-.0259327.0406917-.0402042.0164208-.0164903.0164208-.0164903.0509833-.0515537l.1741754-.1741136c.0134848-.0134849.0240806-.0268085.0765594-.1006364.7284525-.85440973 1.1130575-1.84405595 1.1130575-2.86883755 0-2.91409722-3.1102535-5.29545455-7-5.29545455s-7 2.38135733-7 5.29545455zm-1 0c0-3.53344281 3.60742026-6.29545455 8-6.29545455 4.3925797 0 8 2.76201174 8 6.29545455 0 1.26913937-.4732101 2.48678-1.307795 3.45698115-.0488628.0786951-.1073284.1522129-.1747778.2196622l-.1715221.1714404c-.0323627.0328565-.0323627.0328565-.0534117.0540024-.0194778.0193622-.0194778.0193622-.0435997.0430907l-5.41322205 5.4132221c-.74450393.7445039-2.01748983.2172159-2.01748983-.8356717v-2.2949952c-3.86211333-.4458749-6.81818182-3.0344067-6.81818182-6.22773205z"
          fillRule="nonzero"
        />
      </g>
    </BaseSvgIcon>
  )
}

Comment.defaultProps = {
  id: "comment-icon",
  title: "Comments"
}

export default Comment
